import { useState, useRef, useEffect } from "react";
import ArrowDownMobile from "../../assets/svg/ArrowDownMobile";
import CustomText from "../atomic/CustomText";
import ArrowUpMobile from "../../assets/svg/ArrowUpMobile";

type Section = {
  key: string;
  label: string;
  ref: React.RefObject<HTMLDivElement>;
  disabled?: boolean;
};

interface SectionDropdownProps {
  sections: Section[];
  onSelect: (sectionKey: string) => void;
  current: string;
}

const SectionsDropdown: React.FC<SectionDropdownProps> = ({
  sections,
  onSelect,
  current,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  // close on outside click
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const currentSection = sections.find((s) => s.key === current);

  return (
    <div className="w-full" ref={(el) => (containerRef.current = el)}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex justify-between items-center py-3  rounded bg-white text-left "
      >
        <div className="flex items-center justify-between w-[99%] py-2 px-1 pl-2">
          <CustomText
            text={currentSection?.label}
            fontSize="text-sm"
            fontWeight="font-medium"
            fontColor="#18B5B7"
          />
          {open ? (
            <ArrowUpMobile color="#97A0AF" />
          ) : (
              <ArrowDownMobile color="#97A0AF" />
          )}
        </div>
      </button>

      {open && (
        <div className="absolute z-20 -mt-2 w-[98%] ml-2 border shadow-md bg-white rounded-lg overflow-auto">
          <ul>
            {sections.map((section) => (
              <li key={section.key}>
                <button
                  disabled={section.disabled}
                  onClick={() => {
                    onSelect(section.key);
                    setOpen(false);
                  }}
                  className={`
                    w-full text-left px-4 py-3 flex items-center justify-between
                    ${
                      section.disabled
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-gray-100"
                    }
                    ${current === section.key ? "bg-gray-50 font-semibold" : ""}
                  `}
                >
                  <CustomText
                    text={section.label}
                    fontSize="text-sm"
                    fontWeight="font-medium"
                    fontColor={`${
                      current === section.key ? "#18B5B7" : "#97A0AF"
                    }`}
                  />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SectionsDropdown;
